import MortalityBreakdown from './MortalityBreakdown';

export default MortalityBreakdown;
